export const contactsData = {
    email: 'sreerag.rajan5@gmail.com',
    phone: '+91 9663437669',
    address: '412 Ground Floor, Indraprastha Colony, Sector 30-33, Faridabad, Haryana, 121003',

    sheetAPI: ''
}